import { z } from 'zod';
import { CancerStatus, cancerStatusToString } from './enums/CancerStatus';

export const IamCancerOptions = Object.values(CancerStatus).map((cs) =>
  cancerStatusToString(cs),
);

// The value the option list carries before anything is chosen
const NOTHING_CHOSEN = '-';

export const IamCancerOptionsWithEmptyValue = [
  NOTHING_CHOSEN,
  ...IamCancerOptions,
];

// The patient's own "I am ..." cancer status, chosen from the options the
// forms offer. The list carries '-' while nothing is chosen, so a form value
// left at '-' is the unanswered question it stands for.
//
// @param requiredMessage reported when the field is MISSING; omit for a status
// that need not be answered (add `.optional()` / `.nullish()` at the field).
// A value left at '-' keeps its own message — the field was sent, the question
// just was not answered, and the two are worth telling apart.
export const iamCancerValidation = (requiredMessage?: string) =>
  z
    .string(requiredMessage)
    .refine(
      (value) => IamCancerOptionsWithEmptyValue.includes(value),
      "'Cancer status' is not one of the known values",
    )
    .refine((value) => value !== NOTHING_CHOSEN, "'Cancer status' is required");
